<template>
    <div class="relative">
        <div class="absolute z-10 top-0 left-0 px-2 ">
            <div class="absolute inset-0 bg-grey-darkest opacity-75"></div>
            <div class="relative leading-relaxed text-white uppercase text-xs font-bold tracking-wide">
                {{ label }}
            </div>
        </div>
        <VideoThumbnail
            :videoData="post.video_data"
            :videoSrc="post.video_link"/>
    </div>
</template>

<script>

import VideoThumbnail from "@app/Shared/Components/VideoThumbnail";
import {PostType} from "@admin/Lib/Enums";

export default {

    name: "PostThumbnail",

    props: {
        post: {
            type: Object,
            required: true,
        },
    },

    components: {
        VideoThumbnail
    },

    computed: {
        label() {
            switch (this.post.type) {
                case PostType.Tutorial:
                    return 'Tutorial'
                case PostType.CaseReport:
                    return 'Case Report'
            }
        },
    }
};

</script>
